/** The app's base path with a trailing slash (`/` when unset, e.g. in tests). */
export function appBasePath(): string {
  const base = import.meta.env.APP_BASE_PATH as string | undefined
  if (!base) return '/'
  return base.endsWith('/') ? base : `${base}/`
}

/** The router-relative path of the current browser location (base path removed). */
export function currentRouterPath(): string {
  const base = appBasePath()
  const { pathname, search, hash } = window.location
  const rest = pathname.startsWith(base) ? pathname.slice(base.length - 1) : pathname
  return `${rest || '/'}${search}${hash}`
}

/**
 * The login route with `next`, router-relative. `next` is omitted for `/`
 * and for the login page itself.
 */
export function loginPath(next?: string): string {
  if (!next || next === '/' || next.startsWith('/login')) return '/login'
  return `/login?next=${encodeURIComponent(next)}`
}

/**
 * A safe post-login target: router-relative only. Anything else (absolute
 * URLs, protocol-relative `//host`, backslashes) falls back to `/`.
 */
export function safeNext(next: string | null | undefined): string {
  if (!next?.startsWith('/') || next.startsWith('//') || next.includes('\\')) return '/'
  return next
}
